import { create } from "zustand"
import { AppLocale, DEFAULT_APP_LOCALE } from "@/shared/i18n/translations"

const APP_LOCALE_STORAGE_KEY = "app-locale"

function readInitialLocale(): AppLocale {
  if (typeof window === "undefined") return DEFAULT_APP_LOCALE
  const value = window.localStorage.getItem(APP_LOCALE_STORAGE_KEY)
  return value === "ru" || value === "en" || value === "tonru"
    ? value
    : DEFAULT_APP_LOCALE
}

interface LocaleStoreState {
  locale: AppLocale
  setLocale: (locale: AppLocale) => void
}

export const useLocaleStore = create<LocaleStoreState>((set) => ({
  locale: readInitialLocale(),
  setLocale: (locale) => {
    if (typeof window !== "undefined") {
      window.localStorage.setItem(APP_LOCALE_STORAGE_KEY, locale)
    }
    set({ locale })
  },
}))
